import { Button, Modal } from "antd";
import React, { useState } from "react"; 
const videos = [
    { id: 1, title: "1-video", src: require("../Components/Video/1video.mp4") },
  { id: 2, title: "2-video", src: require("../Components/Video/2video.mp4") },
  { id: 3, title: "3-video", src: require("../Components/Video/3video.mp4") },
  { id: 4, title: "4-video", src: require("../Components/Video/4video.mp4") },
  { id: 5, title: "5-video", src: require("../Components/Video/5video.mp4") },
  { id: 6, title: "6-video", src: require("../Components/Video/6video.mp4") },
  { id: 7, title: "7-video", src: require("../Components/Video/7video.mp4") },
  { id: 8, title: "8-video", src: require("../Components/Video/8video.mp4") },
  { id: 9, title: "9-video", src: require("../Components/Video/9video.mp4") },
  { id: 10, title: "10-video", src: require("../Components/Video/10video.mp4") },
  { id: 11, title: "11-video", src: require("../Components/Video/11video.mp4") },
  { id: 12, title: "12-video", src: require("../Components/Video/12video.mp4") },
  { id: 13, title: "13-video", src: require("../Components/Video/13video.mp4") },
  { id: 14, title: "14-video", src: require("../Components/Video/14video.mp4") },
  { id: 15, title: "15-video", src: require("../Components/Video/15video.mp4") },
];

export const Video = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const showModal = () => setIsModalOpen(true);
    const handleOk = () => setIsModalOpen(false);
    const handleCancel = () => setIsModalOpen(false);
    const handleOpen = (src) => {
        window.open(src, "_blank");
    };
    return (
        <div className="card">
            <Button className="button" onClick={showModal}>
                Video ma'ruzalar
            </Button>

            <Modal
                className="custom-modal"
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={null}
            >
                <br />
                <hr />

                <div className="button-container" style={{ padding: 20, display: "flex", flexDirection: "column", gap: "10px" }}>
                    {videos.map((video) => (
                        <Button className="button" key={video.id} onClick={() => handleOpen(video.src)}>
                            {video.title}
                        </Button>
                    ))}
                </div>

                <hr /> <br />
            </Modal>
        </div>
    );
};
